import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import store from "./state/store";
import Select2 from 'vue3-select2-component'
import BootstrapVue3 from 'bootstrap-vue-3';
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import Maska from 'maska';
import Vue3FormWizard from 'vue3-form-wizard'
import 'vue3-form-wizard/dist/style.css'

import VueFeather from 'vue-feather';
import print from 'vue3-print-nb'
import QRCodeVue3 from "qrcode-vue3";
import '@/assets/scss/config/default/app.scss';
import '@vueform/slider/themes/default.css';
import '@/assets/scss/mermaid.min.css';

import 'vue-loading-overlay/dist/css/index.css';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import Api from "@/helpers/api";
AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});
// URL de l'API pour l'ingestion des logs

// Configuration du gestionnaire d'erreurs global
const app = createApp(App)
    .use(store)
    .use(router)
    .component('apexchart',VueApexCharts)
    .use(BootstrapVue3)
    .component('select2', Select2)
    .component(VueQrcode.name, VueQrcode)
    .component('qrCode', QRCodeVue3)
    .use(print)
    .use(Vue3FormWizard)
.component(VueFeather.type, VueFeather)
    .use(Maska)
    .use(i18n)
    .use(vClickOutside)
app.config.errorHandler = (err, vm, info) => {
    // 1. Loguer l'erreur dans la console pour le développement
    console.error('Vue Error:', err, info);

    // 2. Préparer les données à envoyer
    const errorPayload = {
        level: 'ERROR', // Niveau de log fixe pour les erreurs JS
        channel: 'Backoffice',
        message: err.message,
        context: {
            component_info: info, // Ex: hook d'erreur (mounted hook, watch, etc.)
            stack_trace: err.stack,
            user_agent: navigator.userAgent,
            url: window.location.href,
            user_id: store.state.currentUser?.username || 'anonymous' // Si vous avez l'ID utilisateur
        }
    };
    let api = new Api()

    // 3. Envoyer le log à l'API de manière asynchrone (sans bloquer l'application)
    api.post("/logs/ingest", errorPayload)
        .catch(apiErr => {
            // Si l'API de log échoue, loguer dans la console uniquement
            console.error('Failed to send log to API:', apiErr);
        });
};

    app.mount('#app');